import { FC } from 'react'
import { Progress, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { checkPasswordStrength } from '../../utils/passwordStrength'

const { Text } = Typography

interface PasswordStrengthIndicatorProps {
  password: string
}

export const PasswordStrengthIndicator: FC<PasswordStrengthIndicatorProps> = ({
  password
}) => {
  const { t } = useTranslation('auth')

  const strength = checkPasswordStrength(password)

  return (
    <div style={{ marginTop: '8px' }}>
      <Progress
        percent={strength.score === 1 ? 33 : strength.score === 2 ? 66 : 100}
        showInfo={false}
        strokeColor={strength.color}
        size="small"
        style={{ marginBottom: '4px' }}
        trailColor="#f0f0f0"
      />

      <Text style={{
        fontSize: '11px',
        color: strength.color,
        display: 'block',
        textAlign: 'center'
      }}>
        {t(`passwordStrength.${strength.label}`)}
      </Text>
    </div>
  )
}